import React, { useState } from 'react';
import { AspectRatioOutlined } from '@mui/icons-material';
import { ToggleButton } from '@mui/material';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import RadioGroupInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/RadioGroupInput';
import SliderInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/SliderInput';
import TextInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/TextInput';
import MultiStylePropertyPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/style-inputs/MultiStylePropertyPanel';
import AvatarBlock from './index';
export default function AvatarSidebarPanel({ data, setData }) {
    var _e, _t, _y, _10, _11, _12, _13, _14;
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = AvatarBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    const size = (_t = (_e = data.props) === null || _e === void 0 ? void 0 : _e.size) !== null && _t !== void 0 ? _t : AvatarBlock.defaultData.props.size;
    const imageUrl = (_10 = (_y = data.props) === null || _y === void 0 ? void 0 : _y.imageUrl) !== null && _10 !== void 0 ? _10 : AvatarBlock.defaultData.props.imageUrl;
    const alt = (_12 = (_11 = data.props) === null || _11 === void 0 ? void 0 : _11.alt) !== null && _12 !== void 0 ? _12 : AvatarBlock.defaultData.props.alt;
    const shape = (_14 = (_13 = data.props) === null || _13 === void 0 ? void 0 : _13.shape) !== null && _14 !== void 0 ? _14 : AvatarBlock.defaultData.props.shape;
    return (React.createElement(BaseSidebarPanel, { title: "Avatar block" },
        React.createElement(SliderInput, { label: "Size", iconLabel: React.createElement(AspectRatioOutlined, { sx: { color: 'text.secondary' } }), units: "px", step: 3, min: 32, max: 256, defaultValue: size, onChange: (size) => {
                updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { size }) }));
            } }),
        React.createElement(RadioGroupInput, { label: "Shape", defaultValue: shape, onChange: (shape) => {
                updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { shape }) }));
            } },
            React.createElement(ToggleButton, { value: "circle" }, "Circle"),
            React.createElement(ToggleButton, { value: "square" }, "Square"),
            React.createElement(ToggleButton, { value: "rounded" }, "Rounded")),
        React.createElement(TextInput, { label: "Image URL", defaultValue: imageUrl, onChange: (imageUrl) => {
                updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { imageUrl }) }));
            } }),
        React.createElement(TextInput, { label: "Alt text", defaultValue: alt, onChange: (alt) => {
                updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { alt }) }));
            } }),
        React.createElement(MultiStylePropertyPanel, { names: ['textAlign', 'padding'], value: data.style, onChange: (style) => updateData(Object.assign(Object.assign({}, data), { style })) })));
}
//# sourceMappingURL=AvatarSidebarPanel.js.map